export const ACTIVITY_TYPE_VALUES = ['note', 'task', 'call', 'meeting'];
export const ACTIVITY_TYPE_LABELS = {
    note: 'Notitie',
    task: 'Taak',
    call: 'Gesprek',
    meeting: 'Meeting',
};
export const TASK_PRIORITY_VALUES = ['low', 'normal', 'high'];
export const TASK_PRIORITY_LABELS = {
    low: 'Laag',
    normal: 'Normaal',
    high: 'Hoog',
};
export const CALL_OUTCOME_VALUES = [
    'connected',
    'voicemail',
    'no_answer',
    'wrong_number',
    'scheduled',
    'other',
];
export const CALL_OUTCOME_LABELS = {
    connected: 'Contact',
    voicemail: 'Voicemail',
    no_answer: 'Geen antwoord',
    wrong_number: 'Verkeerd nummer',
    scheduled: 'Afspraak gepland',
    other: 'Overig',
};
export const TIMELINE_FILTER_GROUPS = {
    note: ['note'],
    task: ['task'],
    call: ['call', 'meeting'],
    mail: [
        'mail_sent',
        'mail_campaign_sent',
        'mail_reply',
        'mail_auto_reply',
        'mail_bounce',
        'mail_send_failed',
        'mail_opened',
        'mail_clicked',
        'mail_unsubscribed',
    ],
    system: ['status_change', 'consent', 'stage_change', 'inbound', 'campaign_enrolled'],
};
//# sourceMappingURL=activityTypes.js.map